import Http from "./base-http";

class TaskCard extends Http {
  sendEmail(data){
    return this.client.post(`sendTaskEmail`, data )
  }
}

const TaskCardObj = new TaskCard({
  modelUrlPrefix : ""
});

export default TaskCardObj;